export default __webpack_public_path__ + "static/media/emarginata.5e719f07.jpg";